module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_search-5e28d2c318481b37288adafa83cf1135.gif";